import { render, staticRenderFns } from "./checkout-cart-totals.vue?vue&type=template&id=9b6f7cf0&scoped=true"
import script from "./checkout-cart-totals.vue?vue&type=script&lang=js"
export * from "./checkout-cart-totals.vue?vue&type=script&lang=js"
import style0 from "./checkout-cart-totals.vue?vue&type=style&index=0&id=9b6f7cf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6f7cf0",
  null
  
)

export default component.exports